function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { ANALYTICS_KEY } from '../../constants.js';
import { BackgroundContainer } from '../../layout/BackgroundContainer.js';
import { useLogger } from '../../providers/LoggerProvider.js';
import '../Image/index.js';
import { isYoutube, getYoutubeThumbnail, isWistia, getWistiaThumbnail } from './linkUtils.js';
import { jsx } from 'react/jsx-runtime';
import { Image } from '../Image/Image.js';
const DEFAULT_THUMBNAIL_ALT = 'Video';
function Thumbnail({
  showVideo,
  thumbnailAlt = DEFAULT_THUMBNAIL_ALT,
  thumbnailUrl: customThumbnail,
  mediaUrl,
  loading
}) {
  const _useLogger = useLogger(),
    notifyError = _useLogger.notifyError;
  const _useState = useState(() => {
      if (customThumbnail) return customThumbnail;
      if (isYoutube(mediaUrl)) {
        return getYoutubeThumbnail(mediaUrl);
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    thumbnail = _useState2[0],
    setThumbnail = _useState2[1];
  useEffect(() => {
    if (customThumbnail) {
      setThumbnail(customThumbnail);
      return;
    }
    if (isWistia(mediaUrl)) {
      try {
        getWistiaThumbnail(mediaUrl)?.then(nextThumbnail => nextThumbnail && setThumbnail(nextThumbnail));
      } catch (error) {
        notifyError('Could not extract Youtube video ID from source URL', error.message);
      }
      return;
    }
    if (isYoutube(mediaUrl)) {
      const nextThumbnail = getYoutubeThumbnail(mediaUrl);
      setThumbnail(nextThumbnail);
    }
  }, [customThumbnail, mediaUrl, notifyError]);
  return /*#__PURE__*/jsx(ImageContainer, {
    $freezeAnimation: showVideo,
    background: !thumbnail ? 'backgroundAlternate' : 'transparent',
    "data-qa": ANALYTICS_KEY.Thumbnail,
    children: thumbnail && /*#__PURE__*/jsx(Image, {
      alt: thumbnailAlt,
      src: thumbnail,
      loading: loading
    })
  });
}
const ImageContainer = styled(BackgroundContainer)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  ${({
  $freezeAnimation
}) => $freezeAnimation ? `transition: transform 200000s` : ''};

  &:hover,
  &:focus {
    ${({
  $freezeAnimation
}) => $freezeAnimation ? '' : `transition: transform 5s`};

    transform: scale(1.05);
  }
`;
export { Thumbnail };
//# sourceMappingURL=Thumbnail.js.map
